export const GET_LIST_BLOG_RESULT = 'GET_LIST_BLOG_RESULT';
export const GET_LIST_BLOG = 'GET_LIST_BLOG';
export const GET_LIST_TOP_CLICK = 'GET_LIST_TOP_CLICK';
export const GET_LIST_TOP_CLICK_RESULT = 'GET_LIST_TOP_CLICK_RESULT';
export const GET_COUNT_COUPON_SEND = 'GET_COUNT_COUPON_SEND';
export const GET_COUNT_COUPON_SEND_RESULT = 'GET_COUNT_COUPON_SEND_RESULT';
export const GET_SUM_CLICK_COUPON_SEND = 'GET_SUM_CLICK_COUPON_SEND';
export const GET_SUM_CLICK_COUPON_SEND_RESULT = 'GET_SUM_CLICK_COUPON_SEND_RESULT';
export const GET_CLICK_POPUP_AND_BOOST_SALE = 'GET_CLICK_POPUP_AND_BOOST_SALE';
export const GET_CLICK_POPUP_AND_BOOST_SALE_RESULT1 = 'GET_SUM_CLICK_COUPON_SEND_RESULT1';
